// Fire a one-off celebration from anywhere (local, not from a notification).
// types: confetti | star | fireworks | thumbs_up | checkmark
export const celebrate = (type, title, message = "") =>
  window.dispatchEvent(new CustomEvent("rpg:celebrate", { detail: { type, title, message } }));

// Server responses may carry { celebration: { type, title, message? } } (e.g. first bio / complete profile).
export const celebrateFrom = (data) => { if (data?.celebration) celebrate(data.celebration.type, data.celebration.title, data.celebration.message); };
